import { Link } from 'react-router-dom';
import PageHero from '../components/ui/PageHero';
import { LuShieldCheck, LuLock, LuEye, LuDatabase, LuMail, LuArrowLeft } from 'react-icons/lu';

const IMG = {
  hero: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=900&q=80&auto=format',
};

const SECTIONS = [
  {
    icon: <LuDatabase size={22}/>,
    title: 'Information We Collect',
    content: [
      'Contact form submissions (name, email address, and message content) when you choose to reach out to us.',
      'Newsletter subscription email addresses when you voluntarily sign up for updates.',
      'Anonymous usage analytics such as page views, session duration, and browser type — collected without personal identifiers.',
      'Technical data such as IP address, device type, and referral source for security and performance monitoring purposes.',
    ],
  },
  {
    icon: <LuEye size={22}/>,
    title: 'How We Use Your Information',
    content: [
      'To respond to your enquiries and contact form submissions promptly and accurately.',
      'To send newsletters and updates if you have explicitly subscribed — you can unsubscribe at any time.',
      'To improve the performance, content quality, and user experience of this educational website.',
      'To maintain the security and integrity of our systems and detect any fraudulent or abusive activity.',
    ],
  },
  {
    icon: <LuLock size={22}/>,
    title: 'Data Security',
    content: [
      'All data transmitted to and from this website is protected using HTTPS encryption (TLS 1.3).',
      'Contact form data is handled with industry-standard security practices and stored securely.',
      'We do not sell, rent, or trade your personal information to any third parties under any circumstances.',
      'Access to personal data is restricted to authorised personnel only, on a strictly need-to-know basis.',
    ],
  },
  {
    icon: <LuShieldCheck size={22}/>,
    title: 'Your Rights',
    content: [
      'You have the right to access, correct, or request deletion of any personal data we hold about you.',
      'You can opt out of marketing communications at any time by clicking "Unsubscribe" in any email.',
      'You may request a copy of all data we hold about you by contacting us directly via email.',
      'We will respond to all data rights requests within 30 days in accordance with applicable privacy law.',
    ],
  },
];

function Privacy() {
  return (
    <div className="page-enter">
      {/* Hero */}
      <PageHero
        tag="Legal"
        title="Privacy Policy"
        subtitle="How KI INNOVATION collects, uses, and protects your personal information. Last updated: July 2026."
        breadcrumb={[{ label: 'Privacy' }]}
      >
        <div className="page-hero-img-card">
          <img src={IMG.hero} alt="Data security and privacy protection" loading="lazy" />
        </div>
      </PageHero>

      {/* Content */}
      <section className="page-section bg-dark-2">
        <div className="container">
          <div className="legal-layout">

            {/* Sidebar nav */}
            <aside className="legal-sidebar">
              <div className="legal-sidebar-card">
                <div className="legal-sidebar-title">On This Page</div>
                <ul className="legal-sidebar-nav">
                  {SECTIONS.map((s,i) => (
                    <li key={i}>
                      <a href={`#section-${i}`} className="legal-sidebar-link">
                        <span style={{ color:'var(--primary)' }}>{s.icon}</span>
                        {s.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="legal-sidebar-contact">
                <LuMail size={16} style={{ color:'var(--primary)' }}/>
                <div>
                  <div style={{ fontWeight:700, fontSize:'.83rem', color:'var(--text-2)' }}>Questions?</div>
                  <a href="mailto:info@kiinnovation.in" style={{ fontSize:'.8rem', color:'var(--primary)' }}>
                    info@kiinnovation.in
                  </a>
                </div>
              </div>
            </aside>

            {/* Main content */}
            <main className="legal-main">
              <div className="legal-intro">
                <p>
                  KI INNOVATION is an ki solution dedicated to explaining airport baggage
                  conveyor belt systems. We are committed to protecting your privacy and being
                  transparent about how we handle any information you share with us. This policy
                  explains what data we collect, why we collect it, and your rights regarding that data.
                </p>
              </div>

              {SECTIONS.map((s,i) => (
                <div key={i} id={`section-${i}`} className="legal-section">
                  <div className="legal-section-header">
                    <span className="legal-section-icon">{s.icon}</span>
                    <h2 className="legal-section-title">{s.title}</h2>
                  </div>
                  <ul className="legal-list">
                    {s.content.map((item,j) => (
                      <li key={j}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}

              <div className="legal-section">
                <div className="legal-section-header">
                  <span className="legal-section-icon"><LuMail size={22}/></span>
                  <h2 className="legal-section-title">Cookies</h2>
                </div>
                <p className="legal-para">
                  This website uses essential cookies only — necessary for the site to function correctly
                  (such as remembering your newsletter subscription state). We do not use advertising
                  cookies or third-party tracking cookies. You can disable cookies in your browser
                  settings, but some features of the site may not work as expected.
                </p>
              </div>

              <div className="legal-section">
                <div className="legal-section-header">
                  <span className="legal-section-icon"><LuShieldCheck size={22}/></span>
                  <h2 className="legal-section-title">Contact Us</h2>
                </div>
                <p className="legal-para">
                  If you have any questions about this Privacy Policy or wish to exercise your data rights,
                  please contact us at{' '}
                  <a href="mailto:info@kiinnovation.in" style={{ color:'var(--primary)', fontWeight:600 }}>
                    info@kiinnovation.in
                  </a>
                  . We aim to respond to all enquiries within 2 business days.
                </p>
              </div>

              <div className="legal-back-row">
                <Link to="/" className="btn btn-ghost">
                  <LuArrowLeft size={16}/> Back to Home
                </Link>
                <Link to="/contact" className="btn btn-primary">
                  <LuMail size={16}/> Contact Us
                </Link>
              </div>
            </main>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Privacy;
